(function() {
    'use strict';

    angular
        .module('MW.CoreStream.CsSelectAllHeader', [
            'MW.Framework.TranslationService'
        ])
        .directive('csSelectAllHeader', function () {
            return {
                restrict: 'E',
                scope: {
                    itemType: '@',
                    itemCount: '@',
                    selectedCount: '@',
                    trueAllSelected: '=',
                    resetSelections: '&'
                },
                controllerAs: 'csSelectAllHeaderController',
                controller: CsSelectAllHeaderController,
                templateUrl: 'icm-gaf-legacy/views/contact_manager/partials/cs_select_all_header'
            };
        })
        .controller('CsSelectAllHeaderController', [
            '$scope',
            'translationService',
            CsSelectAllHeaderController
        ]);

    function CsSelectAllHeaderController($scope, translationService) {
        this.$scope = $scope;
        this.translationService = translationService;
        this.itemType = $scope.itemType || 'document';

        // NOTE: when passing a new item type to the directive we need to make sure it is translated
        this.itemSelectedCountString = this.itemType + '-stream__all-selected-on-page';
        this.totalItemSelectedCountString = this.itemType + '-stream__all-selected-in-list';
        this.trueSelectAllString = this.itemType + '-stream__select-all-in-list';

        this.itemSelectedCountMessage = '';
        this.totalItemSelectedCountMessage = '';
        this.trueSelectAllMessage = '';

        this.$scope.$watch('selectedCount', function() {
            if (!this.$scope.trueAllSelected) {
                this.updateSelectedCountMessage();
            }
        }.bind(this));

        this.$scope.$watch('itemCount', function() {
            translationService.getLocalizedString(this.trueSelectAllString, {totalDocuments: this.$scope.itemCount}, true)
                .then(function successLocalized(translatedMessage) {
                    this.trueSelectAllMessage = translatedMessage;
                }.bind(this));
        }.bind(this));
    }

    CsSelectAllHeaderController.prototype.updateSelectedCountMessage = function updateSelectedCountMessage() {
        this.translationService.getLocalizedString(this.itemSelectedCountString, {selectedOnPage: this.$scope.selectedCount}, true)
            .then(function successLocalized(translatedMessage) {
                this.itemSelectedCountMessage = translatedMessage;
            }.bind(this));
        this.translationService.getLocalizedString(this.totalItemSelectedCountString, {selectedOnPage: this.$scope.selectedCount}, true)
            .then(function successLocalized(translatedMessage) {
                this.totalItemSelectedCountMessage = translatedMessage;
            }.bind(this));
    };

    CsSelectAllHeaderController.prototype.setTrueSelectAll = function setTrueSelectAll() {
        this.$scope.selectedCount = this.$scope.itemCount;
        this.updateSelectedCountMessage();
        this.$scope.trueAllSelected = true;
    };

    CsSelectAllHeaderController.prototype.clearSelection = function clearSelection() {
        this.$scope.trueAllSelected = false;
        this.$scope.resetSelections();
    };

    CsSelectAllHeaderController.prototype.isTrueSelectAll = function isTrueSelectAll() {
        if (this.$scope.trueAllSelected) {
            return true;
        }
        else {
            return (this.$scope.selectedCount === this.$scope.itemCount);
        }
    };
}());
